// Local rename-session history (metadata only, no file contents).

const KEY = "rs_history_v1";

export function getSessions() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveSession(entry) {
  const sessions = getSessions();
  sessions.unshift({
    id: Math.random().toString(36).slice(2),
    date: new Date().toISOString(),
    ...entry,
  });
  localStorage.setItem(KEY, JSON.stringify(sessions.slice(0, 50)));
  return sessions;
}

export function clearSessions() {
  localStorage.removeItem(KEY);
}
